import React from "react";
import { Navigation, Link } from "react-router";
import { Grid, Row, Col, Glyphicon} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import Api from "js/utilities/fnapi-client"
import { sidebarOnClicks, mountCode, initDeepLinkData, urlChangeHandler } from "js/utilities/sdk-doc-utils";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import AppnameDisplay from "js/utilities/get-display-appname";
import Loader from "react-loader";
import Zoom from "js/utilities/zoom-handler"
import Amplitude from "js/utilities/amplitude";
import { ZOOM_ICON } from "js/config.jsx";

import ZOOM_SHORT_LOGO from "resources/img/zoom_logo_dark.png";
import CORDOVA_LOGO from "resources/img/cordova.png";
import APPCELERATOR_LOGO from "resources/img/appcelerator.png";
import XAMARIN_LOGO from "resources/img/xamarin.png";
import REACT_LOGO from "resources/img/react_native.png";
import IONIC_LOGO from "resources/img/ionic.png";
import PHONEGAP_LOGO from "resources/img/phonegap.png";
import GITHUB_LOGO from "resources/img/GitHub-Mark-120px-plus.png";
import JS_LOGO from "resources/img/js.png";

export default React.createClass({
  mixins: [Navigation],

  displayName: "download",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    var scrollToElement = initDeepLinkData(this.props);

    return {
      androidDownloading: false,
      iosDownloadingSwift: false,
      iosDownloadingObj: false,
      serverJavaDownloading: false,
      serverCDownloading: false,
      zoomWebDownloading: false,
      zoomWebAngularSampleDownloading: false,
      zoomWebReactSampleDownloading: false,
      zoomWebReactTypescriptSampleDownloading: false,
      zoomServerRestDownloading : false,
      zoomServerDockerDownloading : false,
      zoomServerStandardDownloading : false,
      zoomServerDashboardDownloading : false,
      server_rest_release_version: "",
      server_java_release_version: "",
      server_docker_release_version: false,
      server_standard_release_version: "",
      server_dashboard_release_version: "",
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
    sidebarOnClicks();
  },

  componentWillMount() {
    Zoom.getVersion(this);
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },


  downloadPackage : function(platformString, platformExtension) {
    if (!platformExtension)
      platformExtension = ""
    Zoom.download(platformString).then (() => {
      _.delay(
        function delay() {
          this.setState({androidDownloading : false, iosDownloadingSwift: false, iosDownloadingObjC: false, serverJavaDownloading: false, serverCDownloading: false, zoomWebDownloading: false, zoomWebAngularSampleDownloading: false, zoomWebReactSampleDownloading: false, zoomWebReactTypescriptSampleDownloading: false,zoomAwsDownloading: false, zoomServerRestDownloading: false, zoomServerDockerDownloading: false, zoomServerStandardDownloading: false, zoomServerDashboardDownloading:false});
          Amplitude.send("download-"+platformString+platformExtension);
        }.bind(this),750);
    }).catch((error) => {
      //@TODO: Key off returned response code to be smarter here
      this.context.router.push("/signin");
    })
  },

  _androidDownload : function() {
    this.setState({androidDownloading : true});
    this.downloadPackage("android")
  },

  _iosDownloadSwift : function() {
    this.setState({iosDownloadingSwift : true});
    this.downloadPackage("ios", "swift")
  },

  _iosDownloadObjC : function() {
    this.setState({iosDownloadingObjC : true});
    this.downloadPackage("ios", "objc")
  },

  _serverJavaDownload : function() {
    this.setState({serverJavaDownloading : true});
    this.downloadPackage("server_java")
  },

  _serverCDownload : function() {
    this.setState({serverCDownloading : true});
    this.downloadPackage("server_c")
  },

  _zoomWebDownload : function() {
    this.setState({zoomWebDownloading : true});
    this.downloadPackage("zoom_web")
  },

  _zoomWebAngularSampleDownload : function() {
    this.setState({zoomWebAngularSampleDownloading : true});
    this.downloadPackage("zoom_web_angular_sample")
  },

  _zoomWebReactSampleDownload : function() {
    this.setState({zoomWebReactSampleDownloading : true});
    this.downloadPackage("zoom_web_react_js_sample")
  },

  _zoomWebReactTypescriptSampleDownload : function() {
    this.setState({zoomWebReactTypescriptSampleDownloading : true});
    this.downloadPackage("zoom_web_react_typescript_sample")
  },

  _serverRestDownload : function() {
    this.setState({zoomServerRestDownloading : true});
    this.downloadPackage("server_rest")
  },

  _serverDockerDownload : function() {
    this.setState({zoomServerDockerDownloading : true});
    this.downloadPackage("server_docker")
  },

  _serverStandardDownload : function() {
    this.setState({zoomServerStandardDownloading : true});
    this.downloadPackage("server_standard")
  },


  _serverDashboardDownload : function() {
    this.setState({zoomServerDashboardDownloading : true});
    this.downloadPackage("server_dashboard")
  },


  _getSDKDocVersions : function(cb) {
    SDKDocVersions.get( function _getData(response) {
      return(cb(response));
    });
  },


  releaseBuildDropBox : function() {
    if (!UserHandler.loggedIn()) {
      this.context.router.push("/signin");
      return
    }
    window.open(
      "https://www.dropbox.com/sh/rfwohmof1ddd65t/AABFJ3Hpf3NkI3caBwNS7B4Va?dl=0", "_blank");
  },

  render: function() {
    let server_java_data = ""
    if (this.state.server_java_release_version != "") {
      server_java_data = (
        <a>
          <p><strong onClick={this._serverJavaDownload} className="download-alt">FaceTec Server Core SDK</strong>
          &nbsp;- {!this.state.serverJavaDownloading ? <span className="version"> v{this.state.server_c_release_version}</span> : <span className="version"> Initializing...</span> }
            {!this.state.serverJavaDownloading ? <span className="date"> - <em>Released {this.state.server_c_release_date}</em></span> : <span className="version"></span> }
          </p>
        </a>
      )
    }
    else {
      server_java_data = (
        <span></span>
      )
    }


    let server_rest_data = ""
    if (this.state.server_rest_release_version != "") {
      server_rest_data = (
        <a>
          <p><strong onClick={this._serverRestDownload} className="download-alt">FaceTec Server REST Sample Code</strong>
          &nbsp;- {!this.state.zoomServerRestDownloading ? <span className="version"> v{this.state.server_rest_release_version}</span> : <span className="version"> Initializing...</span> }
            {!this.state.zoomServerRestDownloading ? <span className="date"> - <em>Released {this.state.server_rest_release_date}</em></span> : <span className="version"></span> }
          </p>
        </a>
      )
    }
    else {
      server_rest_data = (
        <span></span>
      )
    }

    let server_docker_data = ""
    if (this.state.server_docker_release_version.length > 3) {
      server_docker_data = (
        <a>
          <p><strong onClick={this._serverDockerDownload} className="download-alt">FaceTec Server Custom Dockerized SDK</strong>
          &nbsp;- {!this.state.zoomServerDockerDownloading ? <span className="version"> v{this.state.server_docker_release_version}</span> : <span className="version"> Initializing...</span> }
            {!this.state.zoomServerDockerDownloading ? <span className="date"> - <em>Released {this.state.server_docker_release_date}</em></span> : <span className="version"></span> }
          </p>
        </a>
      )
    }
    else {
      server_docker_data = (
        <span></span>
      )
    }


    let server_standard_data = ""

    if (this.state.server_standard_release_version.length > 3) {
      server_standard_data = (
        <button onClick={this._serverStandardDownload} className="panel-button">
          <FontAwesome name="cloud" className="fontawesome-icon" />
          <div>
            <h5 className="big">FaceTec Standard Server SDK</h5>
            <p>
              {!this.state.zoomServerStandardDownloading ? <span className="version">Latest Release: {this.state.server_standard_release_version}</span> : <span className="version">Initializing...</span> }
              {!this.state.zoomServerStandardDownloading ? <span className="date"> - {this.state.server_standard_release_date}</span> : <span className="version"></span> }
            </p>
          </div>
        </button>
      )
    }
    else {
      server_standard_data = (
        <span></span>
      )
    }


    let server_dashboard_data = ""
    if (this.state.server_dashboard_release_version.length > 3) {
      server_dashboard_data = (
        <button onClick={this._serverDashboardDownload} className="panel-button">
          <FontAwesome name="cloud" className="fontawesome-icon" />
          <div>
            <h5 className="big">FaceTec Server Dashboard</h5>
            <p>
              {!this.state.zoomServerDashboardDownloading ? <span className="version">Latest Release: {this.state.server_dashboard_release_version}</span> : <span className="version">Initializing...</span> }
              {!this.state.zoomServerDashboardDownloading ? <span className="date"> - {this.state.server_dashboard_release_date}</span> : <span className="version"></span> }
            </p>
          </div>
        </button>
      )
    }
    else {
      server_dashboard_data = (
        <span></span>
      )
    }




    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">
            <section>
              <div className="title">
                <Glyphicon glyph="download" />
                <h2 id="download-the-zoom-sdks">Download The FaceTec SDKs</h2>
              </div>
              <p>Download, integrate, and test the FaceTec Device SDKs.  Once you have spoken to our commercial team, use this page to download the FaceTec Server SDK.</p>
              <hr/>
            </section>
            <section>
              <h2 id="zoom-device-sdks">FaceTec Device SDKs</h2>
              <p>Device SDKs for iOS, Android, and Browser.</p>
              <div className="panel-holder">
                <button onClick={this._iosDownloadSwift} className="panel-button">
                  <FontAwesome name="apple" className="fontawesome-icon" />
                  <div style={{width: "100%"}}>
                    <h5 className="big">iOS</h5>
                    <p>
                      {!this.state.iosDownloadingSwift ? <span className="version">v{this.state.ios_release_version}</span> : <span className="version">Initializing...</span> }
                      {!this.state.iosDownloadingSwift ? <span className="date"> - {this.state.ios_release_date}</span> : <span className="version"></span> }
                    </p>
                  </div>
                </button>
                <button onClick={this._androidDownload} className="panel-button">
                  <FontAwesome name="android" className="fontawesome-icon" />
                  <div style={{width: "100%"}}>
                    <h5 className="big">Android</h5>
                    <p>
                      {!this.state.androidDownloading ? <span className="version">v{this.state.android_release_version}</span> : <span className="version">Initializing...</span> }
                      {!this.state.androidDownloading ? <span className="date"> - {this.state.android_release_date}</span> : <span className="version"></span> }
                    </p>
                  </div>
                </button>
                <button onClick={this._zoomWebDownload} className="panel-button">
                  <FontAwesome name="globe" className="fontawesome-icon" />
                  <div style={{width: "100%"}}>
                    <h5 className="big">Browser</h5>
                    <p>
                      {!this.state.zoomWebDownloading ? <span className="version">v{this.state.zoom_web_release_version}</span> : <span className="version">Initializing...</span> }
                      {!this.state.zoomWebDownloading ? <span className="date"> - {this.state.zoom_web_release_date}</span> : <span className="version"></span> }
                    </p>
                  </div>
                </button>
              </div>

              <hr />

              <h2 id="more-downloads">More Device SDK Downloads</h2>
              <a>
                <p><strong onClick={this._zoomWebAngularSampleDownload} className="download-alt">FaceTec Browser SDK Angular Sample</strong>
                &nbsp;- {!this.state.zoomWebAngularSampleDownloading ? <span className="date"><em>Released {this.state.zoom_web_angular_sample_release_date}</em></span> : <span className="version">Initializing...</span> }
                </p>
              </a>
              <a>
                <p><strong onClick={this._zoomWebReactSampleDownload} className="download-alt">FaceTec Browser SDK React JS Babel Sample</strong>
                &nbsp;- {!this.state.zoomWebReactSampleDownloading ? <span className="date"><em>Released {this.state.zoom_web_react_js_sample_release_date}</em></span> : <span className="version">Initializing...</span> }
                </p>
              </a>
              <a>
                <p><strong onClick={this._zoomWebReactTypescriptSampleDownload} className="download-alt">FaceTec Browser SDK React Typescript Sample</strong>
                &nbsp;- {!this.state.zoomWebReactTypescriptSampleDownloading ? <span className="date"><em>Released {this.state.zoom_web_react_typescript_sample_release_date}</em></span> : <span className="version">Initializing...</span> }
                </p>
              </a>


              <hr />
              {this.state.server_docker_release_version !== false &&
                <div>
                  <h2 id="zoom-server-sdk">FaceTec Server SDK</h2>
                  {this.state.server_docker_release_version === "" && UserHandler.loggedIn() &&
                    <p>Server SDK access is only provided AFTER a Commercial Agreement is signed.  If you have a signed agreement in place, please contact your FaceTec Sales Contact to enable access.  If you DO NOT have a signed Agreement, you cannot access the Server SDK.  <Link to="/quote" target="_blank">Request a Pricing Quote here</Link> to start a conversation with FaceTec's Commercial Team.</p>
                  }
                  {!UserHandler.loggedIn() &&
                    <blockquote><p>You must be <Link to="/signin">Logged In</Link>, and have a signed commercial agreement or a test arrangement to access the Server SDKs.</p></blockquote>
                  }
                  {UserHandler.loggedIn() &&
                    <blockquote><p><strong>New!</strong> FaceTec Standard Server and Server Dashboard are now the recommended approach for new deployments.  All other Server SDK packages are available in the "FaceTec Server Custom SDKs" section below.  FaceTec Server Custom SDKs are still fully supported and will continue to receive updates.  To learn more, see the <Link to="server-sdk-overview">Server SDK Overview Page</Link> and the <Link to="standard-server-and-dashboard">FaceTec Standard Server and FaceTec Server Dashboard Guide</Link>.</p></blockquote>
                  }
                  <div className="panel-holder">
                    {server_standard_data}
                    {server_dashboard_data}
                  </div>

                  <hr />

                  <h2 id="zoom-server-sdk">FaceTec Server Custom SDKs</h2>
                  {!UserHandler.loggedIn() &&
                    <blockquote><p>You must be <Link to="/signin">Logged In</Link>, and have a signed commercial agreement or a test arrangement to access the Server SDKs.</p></blockquote>
                  }
                  <blockquote><p>Note: As of v8.8.0, the FaceTec Server Dockerized SDK is now called the FaceTec Server Custom Dockerized SDK.</p></blockquote>
                    {server_docker_data}
                    {server_rest_data}
                    {server_java_data}
                  <hr />
                </div>
              }

            </section>
            <SDKSidebar menuType="main" title="Downloads"/>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/downloads.jsx